// extracted by mini-css-extract-plugin
export var columnList = "_aq-0";